<template>
  <div class="index-page-bg-fff">
    <!--余额 & 消息通知-->
    <div class="tab-notice-line">
      <div class="left-tab-part">
        <div class="money_title">
          <div
            class="money_each"
            v-for="(item, index) in dataBoardMoneyParams"
            :key="index"
          >
            <img
              :class="[index == 1 ? 'bgOne_no' : 'bgOne']"
              :src="item.bgOneUrl"
              :style="item.bgOneStyle"
              alt=""
            />
            <img
              :class="[index == 1 ? 'bgTow_no_bg' : 'bgTow']"
              v-if="!!item.bgTowUrl"
              :src="item.bgTowUrl"
              :style="item.bgTowStyle"
              alt=""
            />
            <span class="bgTow_no" v-else :style="item.bgTowStyle"></span>
            <div class="text">
              <span>{{ item.name }}</span>
              <span>{{ item.amount }}</span>
              <div class="btn" @click="jumpClick(item.path)">查看详情</div>
            </div>
          </div>
        </div>

        <div class="margin-bg"></div>

        <!-- <div class="title">
          <span class="tab-text notice-text">充值账户信息</span>
        </div>
        <div class="recharge-acc-info">
          <div class="recharge-acc-info-item">
            <div>
              <span class="lable-info">充值账户：</span
              ><span class="value-info">{{ receiptInfo.accountName }}</span>
            </div>

            <div>
              <span class="lable-info">充值账号：</span
              ><span class="value-info" style="padding-bottom: 3px"
                >{{ receiptInfo.accountNumber }}
              </span>
            </div>

            <div>
              <span class="lable-info">打款备注：</span
              ><span class="value-info">{{ receiptInfo.remark }}</span>
            </div>
          </div>

          <div class="recharge-acc-info-item">
            <div>
              <span class="lable-info">开户行：</span>
              <span class="value-info">{{ receiptInfo.depositBank }}</span>
            </div>
            <div>
              <span class="lable-info">行&nbsp;&nbsp;&nbsp;别：</span
              ><span class="value-info">{{ receiptInfo.bankType }}</span>
            </div>
            <div>
              <span class="lable-info">联行号：</span
              ><span class="value-info">{{ receiptInfo.bankBranchCode }} </span>
            </div>
          </div>
        </div> -->
        <el-card class="box-card custom-header" shadow="hover">
          <div slot="header" class="clearfix">
            <span>充值账户信息</span>
          </div>
          <el-row>
            <el-col :span="12">
              <div class="text item">
                充值账户：{{ receiptInfo.accountName || "" }}
              </div>
            </el-col>
            <el-col :span="12">
              <div class="text item">
                开户行：{{ receiptInfo.depositBank || "" }}
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div class="text item">
                充值账号：{{ receiptInfo.accountNumber || "" }}
              </div>
            </el-col>
            <el-col :span="12">
              <div class="text item">
                行&nbsp;&nbsp;&nbsp;别：{{ receiptInfo.bankType || "" }}
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div class="text item">
                打款备注：{{ receiptInfo.remark || "" }}
              </div>
            </el-col>
            <el-col :span="12">
              <div class="text item">
                联行号：{{ receiptInfo.bankBranchCode || "" }}
              </div>
            </el-col>
          </el-row>
        </el-card>
      </div>

      <!-- 消息通知 -->
      <div class="right-notice-part">
        <div class="title el-badge-title">
          <el-badge :value="0" class="item">
            <span class="tab-text notice-text">消息通知</span>
          </el-badge>
        </div>
        <div class="notice-list">
          <div v-if="notice_list.length > 0">
            <div
              v-for="(item, index) in notice_list"
              :key="index"
              class="notice-item"
            >
              <div class="notice-title">
                <div class="left-div">
                  <img src="../../../static/home/notice.png" alt="" />
                  <span>{{ item.title }}</span>
                </div>
                <span>{{ item.date }}</span>
              </div>
            </div>
          </div>
          <div v-else>
            <p style="text-align: center">暂无通知</p>
          </div>
        </div>
      </div>
      <!-- <notice-list></notice-list> -->
    </div>

    <div class="entrance-title">快捷入口</div>

    <!--快捷入口-->
    <div class="data-line">
      <div class="data-item red-item">
        <img
          class="big-icon"
          src="../../../static/home/blue_1.png"
          height="80"
          width="80"
        />
        <button
          class="btnLineFontColor bottom-btn"
          @click="jumpToPage('/task/taskList')"
        >
          发布任务
        </button>
      </div>

      <div class="data-item blue-item">
        <img
          class="big-icon"
          src="../../../static/home/orig_2.png"
          height="80"
          width="80"
        />
        <button
          class="btnLineFontColor bottom-btn"
          @click="jumpToPage('/task/employmentStatement')"
        >
          用工结算
        </button>
      </div>

      <div class="data-item purple-item">
        <img
          class="big-icon"
          src="../../../static/home/pur_3.png"
          height="80"
          width="80"
        />
        <button
          class="btnLineFontColor bottom-btn"
          @click="jumpToPage('/payCenter/billingRecordList')"
        >
          申请开票
        </button>
      </div>

      <div class="data-item green-item">
        <img
          class="big-icon"
          src="../../../static/home/green_4.png"
          height="80"
          width="80"
        />
        <button
          class="btnLineFontColor bottom-btn"
          @click="jumpToPage('/payCenter/electronicReceipt')"
        >
          电子回单
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { getInfo } from "../../api/userMG";
export default {
  name: "index-merchant",
  components: {
    // "notice-list": noticeList,
  },

  data() {
    return {
      notice_list: [
        // {
        //   title: '第一个notice',
        //   date: '10-11'
        // },
        // {
        //   title: '第二个notice',
        //   date: '10-11'
        // },        {
        //   title: '第三个notice',
        //   date: '10-11'
        // }
      ],
      dataBoardMoneyParams: [
        {
          amount: "",
          jumpUrl: "/balanceManage",
          name: "可用余额（元）",
          bgOneStyle: {
            width: "22px",
            height: "22px",
            top: "28px",
            left: "19px",
          },
          bgTowStyle: {
            width: "16px",
            height: "16px",
            top: "25px",
            left: "15px",
          },
          bgOneUrl: "../../static/home/icon_home_yue_up.png",
          bgTowUrl: "../../static/home/icon_home_yue_down.png",
          path: "/payCenter/balanceManage",
        },
        {
          dataType: 1,
          amount: "",
          jumpUrl: "/BusinessStatistics",
          name: "累计结算金额（元）",
          bgOneStyle: {
            width: "20px",
            height: "22px",
            top: "28px",
            left: "21px",
          },
          bgTowStyle: {
            width: "15px",
            height: "18px",
            top: "24px",
            left: "31px",
          },
          bgOneUrl: "../../static/home/icon_home_jiesuan_up.png",
          bgTowUrl: "../../static/home/icon_home_jiesuan_down.png",
          path: "/task/employmentStatement",
        },
        {
          dataType: 2,
          amount: "",
          jumpUrl: "/rechargeRecord",
          name: "累计充值金额（元）",
          bgOneStyle: {
            width: "22px",
            height: "22px",
            top: "28px",
            left: "25px",
          },
          bgTowStyle: {
            width: "16px",
            height: "16px",
            top: "25px",
            left: "21px",
          },
          bgOneUrl: "../../static/home/icon_home_chongzhi_up.png",
          bgTowUrl: "../../static/home/icon_home_chongzhi_down.png",
          path: "/payCenter/rechargeRecord",
        },
        {
          dataType: 4,
          amount: "",
          jumpUrl: "/billingRecordList",
          name: "可开票金额（元）",
          bgOneStyle: {
            width: "19px",
            height: "21px",
            top: "29px",
            left: "24px",
          },
          bgTowStyle: {
            width: "15px",
            height: "17px",
            top: "26px",
            left: "20px",
          },
          bgOneUrl: "../../static/home/icon_home_fapiao_up.png",
          bgTowUrl: "",
          path: "/payCenter/billingRecordList",
        },
      ],
      info: {},
      receiptInfo: {},
    };
  },

  created() {
    // // 获取今天和昨天的日期
    // let today = formatDate(new Date());
    // let yesterday = dateFormat(
    //   new Date().setTime(new Date().getTime() - 24 * 60 * 60 * 1000)
    // );
    // this.tabList[0].paramDate = today;
    // this.tabList[1].paramDate = yesterday;
    // this.xhrIsNeedCompleteContractInformation(); // 弹窗 - 合作评估表
    // this.xhrChangeNoticeLetter(); // 弹窗 - 下载变更通知函
    // // 首页数据看板金额查询
    // for (let i = 0; i < this.dataBoardMoneyParams.length; i++) {
    //   if (!!this.dataBoardMoneyParams[i].dataType) {
    //     this.xhrDataBoardMoney(this.dataBoardMoneyParams[i]);
    //   }
    // }
  },

  mounted() {
    getInfo()
      .then((res) => {
        if (res.msg == "success") {
          this.info = res.data;
          this.dataBoardMoneyParams[0].amount = res.data.balance;
          this.dataBoardMoneyParams[1].amount =
            res.data.cumulativeSettlementAmount;
          this.dataBoardMoneyParams[2].amount =
            res.data.cumulativeRechargeAmount;
          this.dataBoardMoneyParams[3].amount = res.data.invoiceAmount;
          this.receiptInfo = res.data.receiptInfo;
          localStorage.setItem("user_info", JSON.stringify(res.data));
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      })
      .catch((err) => {});
    // this.userMessage = JSON.parse(getLocal("userMessage"));
    // this.whetherCompliance = JSON.parse(getLocal("whetherCompliance"));
    // this.countDown();
    // this.xhrRechargeInfo();
    // this.xhrAccountBalance();
    // this.xhrRiskControlTip(); // 弹窗 - 上传《业务说明交付物》

    // // 如果弹电子合同签约页面则清空历史栈
    // if (localStorage.getItem("routerIndexMer")) {
    //   if (window.history && window.history.pushState) {
    //     // 往历史记录里面添加一条新的当前页面的url
    //     history.pushState(null, null, document.URL);
    //     // 给 popstate 绑定一个方法 监听页面刷新
    //     window.addEventListener("popstate", this.backChange, false); //false阻止默认事件
    //   }
    // }
  },

  methods: {
    // 首页数据看板跳转
    jumpClick(path) {
      console.log(path);
      this.$router.push({ path: path });
    },

    // 跳转页面
    jumpToPage(path, origin) {
      this.$router.push({ path: path });
    },

    // 跳转批次数据准备页面
    jumpToBatch() {
      if (this.batchType) {
        this.$router.push({ name: this.batchType });
      }
    },

    // 签署合同倒计时
    countDown() {
      let that = this;
      let t = setInterval(function () {
        if (that.contractCodeTimer > 1) {
          that.contractCodeTimer--;
          that.contractCodeText = "(" + that.contractCodeTimer + "s)";
          that.btnDisabled = false;
        } else {
          clearInterval(t);
          that.contractCodeTimer = that.contractCodeTimer;
          that.contractCodeText = "";
          that.btnDisabled = true;
        }
      }, 1000);
    },

    backChange() {
      this.$router.push({
        path: "/indexMer",
      });
    },
  },

  beforeCreate() {
    // console.log("商户 beforeCreate");
  },

  beforeDestroy() {
    // console.log("商户 beforeDestroy");
  },

  destroyed() {},
};
</script>

<style>
#listRate .el-table__row {
  width: 342px;
  height: 44px;
  background: #ffffff;
  border: 1px solid #e5e5e5;
}

#listRate .has-gutter {
  width: 684px;
  height: 44px;
}

#listRate .has-gutter .el-table_1_column_1 {
  border-left: 1px solid #e5e5e5;
  border-top: 1px solid #e5e5e5;
}

#listRate .has-gutter .el-table_1_column_2 {
  border-left: 1px solid #e5e5e5;
  border-right: 1px solid #e5e5e5;
  border-top: 1px solid #e5e5e5;
}

#listRate .el-table__row .el-table_1_column_1 {
  border-left: 1px solid #e5e5e5;
}

#listRate .el-table__row .el-table_1_column_2 {
  border-left: 1px solid #e5e5e5;
  border-right: 1px solid #e5e5e5;
}

#noticeLetter .dialog-footer > button {
  padding: 0 10px;
}

#noticeLetter p {
  margin: 0 10px 25px 10px;
}
</style>

<style lang="css" scoped>
.tab-notice-line {
  display: flex;
  justify-content: space-between;
}

.left-tab-part {
  background-color: #ffffff;
  border-radius: 2px;
  width: 63%;
}

.money_title {
  height: 156px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  background-color: #f0f2f5;
}

.money_each {
  position: relative;
  cursor: pointer;
  width: 23.5%;
  background-color: #fff;
  height: 156px;
  background: linear-gradient(173deg, #ebedee 0%, #ffffff 100%);
  box-shadow: 0px 4px 15px 0px rgba(92, 133, 168, 0.1);
  border-radius: 2px;
  border: 1px solid #ffffff;
}

.money_each:nth-child(1) {
  /* border: none;
  background: url("../../../static/home/bg_home_balance.png") no-repeat;
  background-size: 100% calc(100% * (168 / 156));
  background-position: center; */
}

.money_each:hover {
  background-color: #57b2ff;
  background: url("../../../static/home/bg_home_balance.png") no-repeat;
  background-size: 100% calc(100% * (168 / 156));
  background-position: center;
}
.money_each:hover .text span {
  color: #fff !important;
}

.money_each:first-child .text span {
  /* color: #fff!important; */
}

.money_each .btn {
  display: block;
  width: 67px;
  height: 20px;
  background: #ffffff;
  border-radius: 2px;
  font-size: 12px;
  font-family: PingFangTC-Regular, PingFangTC;
  color: #1985ff;
  text-align: center;
  line-height: 20px;
}

.bgOne_no {
  position: absolute;
  z-index: 99;
  backdrop-filter: blur(2px);
  animation: bgOne_no_None 0.2s steps(16) forwards;
  display: block;
}

.bgTow_no_bg {
  position: absolute;
  z-index: 98;
  animation: bgTow_no_None 0.2s steps(16) forwards;
  display: block;
}

.bgOne {
  position: absolute;
  z-index: 99;
  backdrop-filter: blur(2px);
  animation: bgOneNone 0.2s steps(16) forwards;
  display: block;
}

.bgTow {
  position: absolute;
  z-index: 98;
  animation: bgTowNone 0.2s steps(16) forwards;
  display: block;
}

.bgTow_no {
  position: absolute;
  background-color: #1985ff;
  border-radius: 4px;
  z-index: 98;
  animation: bgTowNone 0.2s steps(16) forwards;
  display: block;
}
.money_each .text {
  position: absolute;
  top: 58px;
  display: flex;
  width: 100%;
  height: auto;
  flex-direction: column;
  padding-left: 18px;
}
.money_each .text span {
  display: block;
}
.money_each .text span:nth-child(1) {
  font-size: 12px;
  margin-top: 4px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #8c8c8c;
  margin-bottom: 5px;
}
.money_each .text span:nth-child(2) {
  font-size: 18px;
  font-family: AlibabaSans102Ver2-Medium, AlibabaSans102Ver2;
  color: #272727;
  margin-bottom: 10px;
}
.money_each .text span .btn {
  font-size: 12px;
  font-family: PingFangTC-Regular, PingFangTC;
  color: #1985ff;
}
.margin-bg {
  height: 16px;
  width: 100%;
  background-color: #f0f2f5;
}
.tab-notice-line .title {
  height: 56px;
  line-height: 56px;
  border-bottom: 1px solid #e5e5e5;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.tab-notice-line .title .notice-text {
  color: #272727;
  margin-left: 32px;
  cursor: auto;
  text-align: left;
}
.tab-notice-line .left-tab-part .recharge-acc-info {
  padding-top: 24px;
  display: flex;
}
.tab-notice-line .left-tab-part .recharge-acc-info .recharge-acc-info-item {
  width: 50%;
  padding-left: 32px;
}
.tab-notice-line .left-tab-part .recharge-acc-info .recharge-acc-info-item div {
  display: flex;
}
.tab-notice-line
  .left-tab-part
  .recharge-acc-info
  .recharge-acc-info-item
  .lable-info {
  color: #272727;
}
.tab-notice-line
  .left-tab-part
  .recharge-acc-info
  .recharge-acc-info-item
  span {
  font-size: 14px;
  margin-bottom: 16px;
}
.data-line {
  margin-bottom: 36px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  border-radius: 4px 4px 2px 2px;
}

.data-line .data-item {
  width: 23%;
  height: 230px;
  background-color: #ffffff;
  padding: 0;
  position: relative;
  text-align: center;
}
.data-item .top-bar-img {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
}
.data-item .big-icon {
  display: block;
  margin: 41px auto 33px;
}
.data-item .num-title {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  color: #595959;
}
.data-item .num {
  height: 40px;
  line-height: 40px;
  font-size: 32px;
  color: #272727;
  margin: 16px auto 48px;
}
.data-item .bottom-btn {
  width: 100%;
  height: 44px;
  line-height: 42px;
  border: 1px solid #f56c6c;
  font-size: 16px;
}
.red-item {
  border-top: 8px solid #f56c6c;
}
.red-item .bottom-btn {
  color: #f56c6c;
  border: 1px solid #f56c6c;
}
.blue-item {
  position: relative;
  border-top: 8px solid #409eff;
}
.purple-item {
  position: relative;
  border-top: 8px solid #6255f2;
}
.green-item {
  position: relative;
  border-top: 8px solid #26bfa6;
}
.blue-item,
.purple-item,
.green-item {
  position: relative;
}
.blue-item .num-dianzi {
  font-size: 12px;
  color: #8c8c8c;
  position: absolute;
  left: 0;
  bottom: 100px;
  width: 100%;
}

.blue-item .bottom-btn {
  color: #409eff;
  border: 1px solid #409eff;
}
.purple-item .bottom-btn {
  color: #6255f2;
  border: 1px solid #6255f2;
}

.green-item .bottom-btn {
  color: #26bfa6;
  border: 1px solid #26bfa6;
}
.data-line .data-item .bottom-btn {
  width: 80%;
  height: 44px;
  line-height: 44px;
  font-size: 16px;
  border-radius: 5px;
  background-color: #fff;
  cursor: pointer;
}
.right-notice-part {
  width: 35%;
  background-color: #fff;
  border-radius: 2px;
}
.right-notice-part .title {
  width: 100%;
  height: 56px;
  line-height: 56px;
  border-bottom: 1px solid #e5e5e5;
  box-sizing: border-box;
}
.right-notice-part .notice-list {
  padding: 0 32px;
  margin-bottom: 12px;
  overflow-y: hidden;
  max-height: 240px;
  margin-top: 24px;
}
.right-notice-part .notice-list .notice-item {
  font-size: 14px;
  margin-bottom: 14px;
  cursor: pointer;
}
.right-notice-part .notice-list .notice-item .notice-title {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  width: 100%;
  height: 26px;
}
.right-notice-part .notice-list .notice-item .notice-title div.left-div {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  width: 85%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.right-notice-part .notice-list .notice-item .notice-title div.left-div img {
  width: 26px;
  height: 26px;
}
.right-notice-part .notice-list .notice-item .notice-title div.left-div span {
  color: #272727;
  text-align: left;
  margin-left: 8px;
}
.el-badge__content {
  top: 27px !important;
}
.right-notice-part .notice-text {
  color: #272727;
  margin-left: 32px;
  cursor: auto;
  text-align: left;
  font-size: 16px;
  width: 80px;
  display: inline-block;
}
.notice-text {
  font-size: 16px;
}

.entrance-title {
  margin-top: 24px;
  margin-bottom: 16px;
  font-size: 16px;
  color: #272727;
}

@keyframes bgOne_no_Hover {
  0% {
    transform: translate(0px, 0px);
  }

  100% {
    transform: translate(-4px, 3px);
  }
}

@keyframes bgTow_no_Hover {
  0% {
    transform: translate(0px, 0px);
  }

  100% {
    transform: translate(4px, -3px);
  }
}

@keyframes bgOne_no_None {
  0% {
    transform: translate(-4px, 3px);
  }

  100% {
    transform: translate(0px, 0px);
  }
}

@keyframes bgTow_no_None {
  0% {
    transform: translate(4px, -3px);
  }

  100% {
    transform: translate(0px, 0px);
  }
}

@keyframes bgOneHover {
  0% {
    transform: translate(0px, 0px);
  }

  100% {
    transform: translate(4px, 3px);
  }
}

@keyframes bgOneNone {
  0% {
    transform: translate(4px, 3px);
  }

  100% {
    transform: translate(0px, 0px);
  }
}

@keyframes bgTowHover {
  0% {
    transform: translate(0px, 0px);
  }

  100% {
    transform: translate(-4px, -3px);
  }
}

@keyframes bgTowNone {
  0% {
    transform: translate(-4px, -3px);
  }

  100% {
    transform: translate(0px, 0px);
  }
}

.info-value {
  color: #595959;
  vertical-align: top;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
</style>
<style lang="css">
.el-badge__content {
  top: 27px !important;
}

.custom-header .el-card__header span {
  font-size: 16px;
  font-weight: 500;
}

.text {
  font-size: 14px;
}

.item {
  margin-bottom: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/work/index.vue